define(function (require, exports, module) {
    // project level require imports
    var DataSrcMngr = require('./js/enums/DataSourceList');
    var HBConfig = require('./js/utils/HeartbeatConfig');
    var GamestateFilter = require('./js/utils/GamestateFilter');
    // fetch polyfill
    var fetch = require('whatwg-fetch/fetch'); // eslint-disable-line no-unused-vars

    function GameDataPacemaker () {

    }

    GameDataPacemaker.prototype = {
        init: function (datasources, configs, gamestates) {
            DataSrcMngr.setDatasourceNames(datasources);
            HBConfig.init(configs);
            GamestateFilter.init(gamestates);
        }
    };

    return new GameDataPacemaker();
});
